import { formatNumber } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'numberPipe' })
export class NumberPipe implements PipeTransform {

    private locale: string;

    constructor(
        private myTranslateService: TranslateService,
    ) {
    }

    public transform(value: any, digitsInfo?: string, locale?: string): string | null {
        this.locale = locale ? locale : this.myTranslateService.instant('sla-core.commons.locale');

        const result: string = formatNumber(value, this.locale, digitsInfo);
        return this.replaceSeperators(result);
    }

    private replaceSeperators(value: string): string {
        if (value !== null && value !== undefined) {
            const decimalDefault: string = this.getDecimal(true);
            const thousandDefault: string = this.getThousand(true);
            let valueThousand: string = value.split(decimalDefault)[ 0 ];
            const valueDecimal: string = value.split(decimalDefault)[ 1 ];
            const decimal: string = this.getDecimal();
            const thousand: string = this.getThousand();
            const regexT: RegExp = new RegExp(`[${ thousandDefault }]`, 'g');
            valueThousand = valueThousand.replace(regexT, thousand);
            if (valueDecimal) {
                value = valueThousand + decimal + valueDecimal;
            } else {
                value = valueThousand;
            }
        }
        return value;
    }

    private getDecimal(def?: boolean): string {
        let locale: string = this.locale || this.myTranslateService.instant('sla-core.commons.locale');
        if (locale === 'sla-core.commons.locale') {
            console.warn('sla-core.commons.locale not found in translation file! Using default "de"');
            locale = 'de';
        }
        let separator: string = formatNumber(1.1, locale, '1.1-1').charAt(1);
        if (this.myTranslateService.instant('sla.commons.decimal-separator.value') !== 'sla.commons.decimal-separator.value' && !def) {
            separator = this.myTranslateService.instant('sla.commons.decimal-separator.value');
        }
        return separator;
    }

    private getThousand(def?: boolean): string {
        let locale: string = this.locale || this.myTranslateService.instant('sla-core.commons.locale');
        if (locale === 'sla-core.commons.locale') {
            console.warn('sla-core.commons.locale not found in translation file! Using default "de"');
            locale = 'de';
        }
        let separator: string = formatNumber(100000, locale, '1.0-0').charAt(3);
        if (this.myTranslateService.instant('sla.commons.thousand-separator.value') !== 'sla.commons.thousand-separator.value' && !def) {
            separator = this.myTranslateService.instant('sla.commons.thousand-separator.value');
        }
        return separator;
    }

}
